import { render, staticRenderFns } from "./FlavorPieChart.vue?vue&type=template&id=15b305c8&scoped=true&"
import script from "./FlavorPieChart.vue?vue&type=script&lang=js&"
export * from "./FlavorPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b305c8",
  null
  
)

export default component.exports